import React, { FC, memo } from "react";
import clsx from "clsx";

import s from "./styles.less";

interface Props {
  id?: string;
  disabled?: boolean;
  loading?: boolean;
  customClassName?: string;
  customClassNameLoading?: string;
  checked?: boolean;
  name?: string;
  onCheck?: (e) => void;
}

const Checkbox: FC<Props> = ({
  id,
  customClassName,
  customClassNameLoading,
  disabled = false,
  loading = false,
  checked,
  onCheck,
  name,
}) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <label
        className={clsx({
          [s.checkbox]: true,
          [customClassName]: true,
        })}
      >
        <input
          id={id}
          className={s.checkbox_input}
          type="checkbox"
          name={name}
          checked={checked}
          onChange={(e) => onCheck(e.target.checked)}
          disabled={disabled}
        />
        {loading ? (
          <div
            className={clsx(s.loading, {
              [customClassNameLoading]: true,
            })}
          />
        ) : (
          <span className={s.checkbox_span} />
        )}
      </label>
    </div>
  );
};

export default memo(Checkbox);
